var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton"},_vm._l((4),function(n){return _c('div',{key:n,staticClass:"skeleton-line"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }